import React, { useRef, useState, useEffect } from "react";

// Wiederverwendbarer Mikrofon-Button für Spracheingabe.
// onText(transkript) wird bei jedem erkannten Satz aufgerufen.
export default function MikrofonButton({ onText, style }) {
  const [hoeren, setHoeren] = useState(false);
  const erkennungRef = useRef(null);

  useEffect(() => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return;
    const erk = new SR();
    erk.lang = "de-DE";
    erk.continuous = true;
    erk.interimResults = false;
    erk.onresult = (e) => {
      for (let i = e.resultIndex; i < e.results.length; i++) {
        if (e.results[i].isFinal) {
          onText(e.results[i][0].transcript.trim());
        }
      }
    };
    erk.onend = () => setHoeren(false);
    erkennungRef.current = erk;
    return () => erk.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!(window.SpeechRecognition || window.webkitSpeechRecognition)) return null;

  const toggeln = () => {
    if (!erkennungRef.current) return;
    if (hoeren) { erkennungRef.current.stop(); setHoeren(false); }
    else { erkennungRef.current.start(); setHoeren(true); }
  };

  return (
    <button
      type="button"
      onClick={toggeln}
      title={hoeren ? "Aufnahme stoppen" : "Sprache aufnehmen"}
      style={{
        padding: "0.35rem 0.6rem",
        border: "1px solid #ccc",
        borderRadius: "20px",
        cursor: "pointer",
        fontSize: "0.8rem",
        backgroundColor: hoeren ? "#ea4335" : "#f0f2f5",
        color: hoeren ? "white" : "#333",
        ...style,
      }}
    >
      {hoeren ? "🔴 Aufnahme..." : "🎙️"}
    </button>
  );
}
